import React from 'react';
import RetirementCalculator from '../components/calculators/RetirementCalculator';
import FAQ from '../components/FAQ';
import SEO from '../components/shared/SEO';

const RetirementPage: React.FC = () => {
  const faqs = [
    {
      question: "How much should I save for retirement?",
      answer: "A common rule of thumb is to save 10-15% of your gross income for retirement, but the actual amount depends on factors like your age, lifestyle, and retirement goals."
    },
    {
      question: "When should I start saving for retirement?",
      answer: "The earlier you start saving, the better, due to compound interest. Ideally, start saving in your 20s, but it's never too late to begin."
    },
    {
      question: "What's the 4% rule?",
      answer: "The 4% rule suggests you can withdraw 4% of your retirement savings annually, adjusted for inflation, with a high probability of not running out of money over a 30-year retirement."
    },
    {
      question: "How does Social Security fit into retirement planning?",
      answer: "Social Security provides a baseline retirement income, but it's designed to replace only about 40% of your pre-retirement income. Additional savings are usually necessary."
    },
    {
      question: "What factors aren't included in this calculator?",
      answer: "This calculator doesn't account for Social Security benefits, pension income, inflation adjustments, or varying market returns. Consider these factors when planning."
    }
  ];

  return (
    <>
      <SEO 
        title="Retirement Savings Calculator"
        description="Plan for your retirement with our comprehensive retirement calculator. Estimate savings, calculate contributions, and visualize your retirement nest egg."
        keywords={[
          'retirement calculator',
          'retirement planning',
          'retirement savings',
          'retirement age',
          'retirement income',
          'pension calculator',
          'retirement nest egg',
          'retirement projection',
          'retirement goals',
          'retirement planner'
        ]}
      />
      <RetirementCalculator />
      <FAQ faqs={faqs} />
    </>
  );
};

export default RetirementPage;